export const mainNum = 9

export const SHELF_TEMPLATE = 'shelfTemplate' // 铺货模板内的发货模式
export const SHELF_SHOP = 'shelfShop' // 单个上架的发货模式

export const DELIVERY_TIME_LABEL = '发货时效'
export const DELIVERY_TIME_REAL_NAME = 'deliveryTime'

/** 铺货模板 AI 打标字段（值与 templatePropId / aiFullItemId 一致，行尾为中文说明） */
export const SHELF_TEMPLATE_MAP = {
    ITEM_NAME: 'ITEM_NAME', // 标题-截取
    DESCRIPTION: 'DESCRIPTION', // 描述设置
    PRESELL_TYPE: 'PRESELL_TYPE', // 发货模式
    SKU_STOCK: 'SKU_STOCK', // 库存
    SKU_PRICE: 'SKU_PRICE', // 价格
}
